/**
 * @generated SignedSource<<a17efcb5e0c41f304da35ba7c9f2a4f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigatorUI_jiraView$data = {
  readonly __typename: string;
  readonly conditionalFormattingRules?: {
    readonly edges: ReadonlyArray<{
      readonly __typename: "JiraFormattingRuleEdge";
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly error: {
    readonly extensions: ReadonlyArray<{
      readonly statusCode: number | null | undefined;
    }> | null | undefined;
    readonly message: string | null | undefined;
  } | null | undefined;
  readonly fieldSets?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly fieldSetPreferences: {
          readonly isFrozen?: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly savedViewId?: string | null | undefined;
  readonly viewSettings?: {
    readonly canEnableGrouping: boolean | null | undefined;
    readonly isGroupingEnabled: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BulkOperationsWrapper_ViewSettings" | "MigrateListConfigClickListener_JiraView" | "main_issueNavigator_FullPageIssueApp_view" | "main_issueNavigator_Header_jiraViewResult" | "main_issueNavigator_IssueResults_jiraView" | "main_issueNavigator_SidebarLayout_view" | "topBar_issueNavigator_jiraViewResult">;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigatorUI_jiraView";
};
export type main_issueNavigator_IssueNavigatorUI_jiraView$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigatorUI_jiraView$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigatorUI_jiraView">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "amountOfColumns"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsScope"
    },
    {
      "kind": "RootArgument",
      "name": "groupBy"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isSavedViewConditionalFormattingEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "kind": "RootArgument",
      "name": "settings"
    },
    {
      "kind": "RootArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueNavigatorUI_jiraView",
  "selections": [
    (v0/*: any*/),
    {
      "concreteType": "QueryError",
      "kind": "LinkedField",
      "name": "error",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "extensions",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "statusCode"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "message"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_Header_jiraViewResult"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_IssueResults_jiraView"
    },
    {
      "kind": "FragmentSpread",
      "name": "topBar_issueNavigator_jiraViewResult"
    },
    {
      "kind": "FragmentSpread",
      "name": "MigrateListConfigClickListener_JiraView"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "main_issueNavigator_FullPageIssueApp_view"
        },
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "savedViewId"
            }
          ]
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "fieldSetSelectedState": "SELECTED"
              }
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "amountOfColumns"
            },
            {
              "kind": "Variable",
              "name": "scope",
              "variableName": "fieldSetsScope"
            }
          ],
          "concreteType": "JiraIssueSearchFieldSetConnection",
          "kind": "LinkedField",
          "name": "fieldSets",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueSearchFieldSetEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraIssueSearchFieldSet",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraFieldSetPreferences",
                      "kind": "LinkedField",
                      "name": "fieldSetPreferences",
                      "plural": false,
                      "selections": [
                        {
                          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx",
                          "kind": "Condition",
                          "passingValue": true,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "isFrozen"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraIssueSearchViewMetadata",
      "abstractKey": "__isJiraIssueSearchViewMetadata"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "BulkOperationsWrapper_ViewSettings"
            }
          ]
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "isSavedViewConditionalFormattingEnabled",
              "variableName": "isSavedViewConditionalFormattingEnabled"
            }
          ],
          "kind": "FragmentSpread",
          "name": "main_issueNavigator_SidebarLayout_view"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "groupBy",
              "variableName": "groupBy"
            },
            {
              "kind": "Variable",
              "name": "issueSearchInput",
              "variableName": "issueSearchInput"
            },
            {
              "kind": "Variable",
              "name": "settings",
              "variableName": "settings"
            },
            {
              "kind": "Variable",
              "name": "staticViewInput",
              "variableName": "staticViewInput"
            }
          ],
          "concreteType": "JiraIssueSearchViewConfigSettings",
          "kind": "LinkedField",
          "name": "viewSettings",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isGroupingEnabled"
            },
            {
              "kind": "ScalarField",
              "name": "canEnableGrouping"
            }
          ]
        },
        {
          "condition": "isSavedViewConditionalFormattingEnabled",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 20
                }
              ],
              "concreteType": "JiraFormattingRuleConnection",
              "kind": "LinkedField",
              "name": "conditionalFormattingRules",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraFormattingRuleEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/)
                  ]
                }
              ],
              "storageKey": "conditionalFormattingRules(first:20)"
            }
          ]
        }
      ],
      "type": "JiraSpreadsheetView",
      "abstractKey": "__isJiraSpreadsheetView"
    }
  ],
  "type": "JiraView",
  "abstractKey": "__isJiraView"
};
})();

(node as any).hash = "bbf84cd459284c7270eac4dcee2ad37a";

export default node;
